
import Vue from 'vue'
import Router from 'vue-router'
import store from '../storage'

import account from "./modules/cuenta";
import global from "./modules/global";
import profile from "./modules/perfil";
import ver from "./modules/_ver"

import curse from "./curse";
import jobs from "./jobs";
import enterprise from "./enterprise";
import buzon from "./buzon";
import home from "./home";
import redsocial from "./redsocial";
import landing from "./landing";



Vue.use(Router)
const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home-page',
			component: () => import('@/views/Home.vue')
		},
		{
			path: '/notificaciones',
			component: () => import('@/components/#pages/notifications/Notifications.vue'),
			meta: {
				requiresAuth: true
			},
		},
		...global,
		...landing,
		...account,
		...profile,
		...curse,
		...jobs,
		...enterprise,
		...buzon,
		...home,
		...ver,
		...redsocial
	]
})


router.beforeEach((to, from, next) => {

	store.commit(
		"setRouterHistory",
		from
	);

	if(to.matched.some(record => record.meta.requiresAuth)) {
		store.commit(
			"setRouteData",
			{requireAuth: true}
		);
		if(store.getters.isLoggedIn) {
			next()
			return
		}
		next('/login')
	}else if(to.matched.some(record => record.meta.protectedLogin)){
		store.commit(
			"setRouteData",
			{requireAuth: true}
		);
		if(store.getters.isLoggedIn){
			next('/perfil')
		}else{
			store.commit(
				"setRouteData",
				{requireAuth: false}
			);
			next()
			return
		}
	}else {
		next()
	}
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js